import React, { useState } from 'react';
import { Container, Row, Col, Accordion, Form, InputGroup } from 'react-bootstrap';
import { BsSearch, BsChevronLeft } from 'react-icons/bs';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/auth';

// FAQ data
const faqData = [
    {
        id: 'faq-1',
        question: 'What is e-Way Bill?',
        answer: 'An e-way bill is an electronic document required under India\'s Goods and Services Tax (GST) framework for transporting goods worth more than ₹50,000.'
    },
    {
        id: 'faq-2',
        question: 'What is e-Way Bill consent (IBDIC)?',
        answer: 'E-Way Bill verification plays a vital role in enabling lenders to confirm whether an invoice presented for financing is genuine and compliant. This consent is in the form of credentials of the e-Way Bill portal (via GSPs).'
    },
    {
        id: 'faq-3',
        question: 'Why is consent required?',
        answer: 'The e-Way Bill consent provided by the corporate(s) to IBDIC allows the IBDIC\'s partner lender(s) to verify the invoices (for authenticity).'
    },
    {
        id: 'faq-4',
        question: 'Who can give consent?',
        answer: 'The authorized corporate user of the GSTIN (as registered on the e-Way Bill portal) can give consent.'
    },
    {
        id: 'faq-5',
        question: 'What is a GSP?',
        answer: 'A GST Suvidha Provider (GSP) is an authorized entity that provides taxpayers with a platform to access and interact with India\'s Goods and Services Tax (GST) portal. (for more details, please refer: https://gstn.org.in/gsp-ecosystem)'
    },
    {
        id: 'faq-6',
        question: 'How do I give consent to a new GSP?',
        answer: 'Follow these official steps:\n1. Login to ewaybillgst.gov.in.\n2. Go to Registration → For GSP.\n3. Click Send OTP, verify using the registered mobile/email.\n4. Click Add New / Add GSP.\n5. Select your GSP from the dropdown (e.g., Cygnet, ClearTax, etc.).\n6. Create a User Name (with suffix) and a Password (12-15 characters).\n7. Click Add → success message "GSP User Added Successfully" confirms consent is given.'
    },
    {
        id: 'faq-7',
        question: 'Can I have multiple GSPs for the same GSTIN?',
        answer: 'Yes, you can register multiple GSPs for different purposes — e.g., one for tax filing and another for e-Way Bill operations.\nEach GSP will have its own username and password credentials under your GSTIN.'
    },
    {
        id: 'faq-8',
        question: 'My company uses a GSP for tax filing (returns). Can I add another one for e-Way Bills?',
        answer: 'Yes, the GST Return filing GSP and the e-Way Bill GSP are two separate systems.\nYou can safely add another GSP specifically for e-Way Bill integration without any interference.'
    },
    {
        id: 'faq-9',
        question: 'Can I edit my user profile?',
        answer: 'Yes, a corporate user can update their user profile (email/mobile).'
    },
    {
        id: 'faq-10',
        question: 'Can I provide multiple consents per user?',
        answer: 'Yes, corporate user can submit multiple consents.'
    },
    {
        id: 'faq-11',
        question: 'Can I revoke or remove consent?',
        answer: 'Yes, corporate can remove/revoke consent at any time.'
    },
    {
        id: 'faq-12',
        question: 'What information can IBDIC see for my consent?',
        answer: 'IBDIC uses the consent for invoice verification via e-Way bill route. IBDIC can only verify the invoices for which the e-Way bill is present. IBDIC does not have the access or visibility to the GSTN returns/other E-way bills/any other data.'
    }
];

export const FAQ = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredFaqs, setFilteredFaqs] = useState(faqData);

    // Filter FAQs based on search query
    const handleSearch = (e) => {
        const query = e.target.value.toLowerCase();
        setSearchQuery(query);
        
        if (!query) {
            setFilteredFaqs(faqData);
            return;
        }
        
        const filtered = faqData.filter(faq => 
            faq.question.toLowerCase().includes(query) || 
            faq.answer.toLowerCase().includes(query)
        );
        
        setFilteredFaqs(filtered);
    };

    const { user } = useAuth();

    return (
        <Container fluid className="py-5">
            <Row className="mb-5">
                <Col md={10} className="mx-auto">
                    <Link to={user?.hasConsents ? '/home' : '/new-consent'} className='fw-bold mb-4 d-inline-block text-decoration-none'>
                        <BsChevronLeft className='me-1' />Back
                    </Link>
                    <h1 className="display-5 mb-4">Frequently Asked Questions</h1>
                    
                    <InputGroup className="mb-5">
                        <InputGroup.Text id="search-addon">
                            <BsSearch />
                        </InputGroup.Text>
                        <Form.Control
                            placeholder="Search FAQs..."
                            aria-label="Search FAQs"
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                    </InputGroup>
                    
                    {filteredFaqs.length === 0 ? (
                        <div className="text-center py-5">
                            <h4>No FAQs found matching your search.</h4>
                            <p>Try different keywords or browse again.</p>
                        </div>
                    ) : (
                        <Accordion defaultActiveKey={[]} alwaysOpen className="mb-4">
                            {filteredFaqs.map(faq => (
                                <Accordion.Item key={faq.id} eventKey={faq.id}>
                                    <Accordion.Header>{faq.question}</Accordion.Header>
                                    <Accordion.Body>
                                        {faq.answer.split('\n').map((text, index) => (
                                            <React.Fragment key={index}>
                                                {text}
                                                {index < faq.answer.split('\n').length - 1 && <br />}
                                            </React.Fragment>
                                        ))}
                                    </Accordion.Body>
                                </Accordion.Item>
                            ))}
                        </Accordion>
                    )}
                </Col>
            </Row>
        </Container>
    );
};
